var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.minutes < 0)?_c('span',[_vm._t("negative",[_vm._v(_vm._s(_vm.result))],{"text":_vm.result})],2):_c('span',[_vm._t("positive",[_vm._v(_vm._s(_vm.result))],{"text":_vm.result})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }